export default import.meta.ROLLDOWN_FILE_URL_luuwvyWVpL4bTX5MXmRXrg